/**
 * Zusammenfassung über den Abschnitten: was Formular oder Server beanstanden, je Zeile mit Abschnitt
 * und Sprung dorthin – so tut „Wirkung prüfen“ oder „Aus speichern“ nie still nichts.
 */
import { goToSection } from './ConfigurationSectionNavigation';
import { SECTION_SHORT, sectionNumber, type FieldIssue } from './configurationSections';

export function ConfigurationIssueSummary({
  issues,
  server,
}: {
  issues: readonly FieldIssue[];
  /** Kommen die Befunde vom Server? Sonst aus dem Formular. */
  server: boolean;
}) {
  if (issues.length === 0) return null;
  return (
    <section
      role="alert"
      className="bg-sealwax-tint rounded-tile flex flex-col gap-0.5 px-[18px] py-4"
    >
      <span className="text-sealwax text-sm font-bold">
        {server
          ? 'Die Prüfung auf dem Server verhindert das Speichern:'
          : 'Bitte prüfe die markierten Angaben:'}
      </span>
      {issues.map((issue, index) => (
        <button
          key={`${index}-${issue.field}`}
          type="button"
          onClick={() => goToSection(issue.section)}
          className="text-sealwax flex min-h-11 flex-col justify-center text-left text-[13px] underline-offset-2 hover:underline"
        >
          <span>
            {sectionNumber(issue.section)} · {SECTION_SHORT[issue.section]}: {issue.message}
          </span>
          {issue.detail && (
            <span className="text-ink-soft font-mono text-[11px]">Server: {issue.detail}</span>
          )}
        </button>
      ))}
    </section>
  );
}

/** Ein neuer Stand vom Server hat einen geänderten Entwurf ersetzt (`useConfigurationReset`). */
export function ConfigurationReplacedNotice({ version }: { version: number | null }) {
  if (version === null) return null;
  return (
    <p role="status" className="bg-amber-tint text-ink rounded-tile p-4 text-sm">
      Inzwischen gilt Version {version} – der Stand ist neu geladen. Prüfe, ob deine Eingaben darin
      enthalten sind.
    </p>
  );
}
